<template>
  <notifications />
  <router-view />
  <WebSocket
    ref="websocket"
    :token="{ jwt }"
    @receivedMessageEvent="receivedMessageEvent"
    v-if="jwt !== ''"
  />
</template>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap');

  * {
    margin: 0;
    padding: 0;
    font-weight: 400;
    font-size: 16px;
    font-family: 'Lexend', Arial, Helvetica, sans-serif;
  }

  html {
    overflow-x: hidden;
  }

  body {
    min-width: 100vw;
    min-height: 100vh;
    scrollbar-color: rgba(255, 255, 255, 0.9) var(--bg);
    scrollbar-width: thin;
  }

  #app {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  :root {
    --bg: black;
    --surface-dark: rgba(24, 26, 28, 0.9);
    --surface: rgba(48, 53, 56, 0.9);
    --surface-semilight: rgba(60, 66, 70, 0.9);
    --surface-light: rgba(72, 80, 84, 0.9);
    --surface-superlight: rgba(96, 106, 112, 0.9);

    --border-colour: rgba(255, 255, 255, 0.15);
    --border-style: 2px solid;
    --border: var(--border-style) var(--border-colour);
    --separator: 1px dashed rgba(255, 255, 255, 0.25);
    --shadow: 0 8px 24px rgba(0, 0, 0, 0.75);
    --border-radius: 5px;

    --modal-bg: rgba(0, 0, 0, 0.3);

    --accent: hsl(359, 100%, 68%);
    --accent-faint: hsla(359, 100%, 68%, 50%);

    --text: #eee;
    --text-faint: #888;

    --warn: hsl(45, 70%, 50%);

    --error: hsl(0, 70%, 50%);

    --success: hsl(120, 50%, 50%);
    --success-disabled: hsl(120, 10, 50, 1);

    /* Needed for datetime-popper on livevideo */
    --popper-theme-background-color: var(--surface);
    --popper-theme-background-color-hover: var(--surface);
    --popper-theme-text-color: var(--text);
    --popper-theme-border-width: 0px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 6px;
    --popper-theme-padding: 32px;
    --popper-theme-box-shadow: var(--shadow);
  }

  * {
    transition:
      color 0.2s ease,
      background-color 0.2s ease-out;
  }

  *:focus {
    outline: none;
  }

  input:focus,
  textarea:focus,
  input:active,
  textarea:active {
    outline: var(--border-style) var(--accent);
  }
</style>

<script>
  import Notifications from '@/components/Notifications.vue';
  import WebSocket from '@/components/WebSocket.vue';
  import bus from '@/utils/EventBus';
  import store from './store/index';
  export default {
    name: 'App',
    components: {
      WebSocket,
      Notifications,
    },
    computed: {
      jwt() {
        return this.$store.getters.getToken;
      },
    },
    methods: {
      receivedMessageEvent(message) {
        bus.$emit('receivedMessageEvent', message);
      },
      setupConsoleColours() {
        console.red = (str) => {
          console.log(`%c${str}`, 'color: black; background-color: red;');
        };
        console.yellow = (str) => {
          console.log(`%c${str}`, 'color: black; background-color: yellow;');
        };
        console.green = (str) => {
          console.log(`%c${str}`, 'color: black; background-color: green;');
        };
        console.blue = (str) => {
          console.log(`%c${str}`, 'color: blue;');
        };
        console.cyan = (str) => {
          console.log(`%c${str}`, 'color: cyan;');
        };
      },
    },
    mounted() {
      store.dispatch('googleAuth/checkAuthenticatedWithGoogle');
      this.setupConsoleColours();
    },
  };
</script>
